import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Padronagem } from 'src/app/models/api/comercial/padronagem';

@Injectable({
  providedIn: 'root'
})
export class ApiPadronagemService {
  private baseUrl = 'Padronagem';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Padronagem[]>('');
  }
}
